import { IAccountMutationForm, IUpdateAccount } from 'services/accounts/types';

export const accountFormToAccountQuery = (
  accountForm: IAccountMutationForm
): IUpdateAccount => {
  return {
    magellanAccountId: accountForm.id,

    accountName: accountForm.accountName,
    apiEndpoint: accountForm.endpoint,
    clientEndpoint: accountForm.clientEndpoint,
    apiKey: accountForm.apiKey,
  };
};
